import {Injectable} from '@angular/core';
import {take} from 'rxjs/operators';
import {InteractionPathOpener, OpenInteractionPathRequest} from '@webmate-web-core/shared/services/interactionpath-opener.service';
import {DeployableService} from '@webmate-web-core/shared/services/device/deployable.service';
import {CurrentProjectService} from '@webmate-web-core/shared/services/current-project.service';
import {WorkbenchOpenService} from '@webmate-web-core/shared/workbench-ipc';

/**
 * The strategy for opening InteractionPaths in webmate is to open the InteractionPath in
 * the workbench, which will then open the corresponding browser session and navigate to the InteractionPath.
 */
@Injectable({
    providedIn: 'root'
})
export class WebmateInteractionPathOpenerService implements InteractionPathOpener {
    constructor(
        private deployableService: DeployableService,
        private currentProjectService: CurrentProjectService,
        private workbenchOpenService: WorkbenchOpenService,
    ) {}

    open(request: OpenInteractionPathRequest): void {
        const projectId = request.projectId ?? this.currentProjectService.getCurrentProjectId();
        if (!projectId) {
            console.error('Could not determine project to open workbench for interaction path');
            return;
        }

        this.deployableService.getLatestBrowserVersionForProject$(
            projectId,
            request.browser?.browserType ?? 'chrome',
            request.browser?.platform.getPlatformFamily() ?? 'desktop'
        ).pipe(take(1)).subscribe(browser => {
            if (!browser) {
                console.error('Could not find browser to open workbench for interaction path');
                return;
            }

            const browserExpeditionStartConfig = {
                browserType: browser.browserType,
                browserVersion: browser.version,
                interactionPaths: [request.interactionPath]
            };
            this.workbenchOpenService.openWorkbench({
                projectId,
                auditId: request.auditId,
                browserExpeditionStartConfig
            }, {
                blockedPopupMessage: 'Your browser has blocked the workbench, please allow pop-ups / new tabs for this webpage!'
            }).pipe(take(1)).subscribe();
        });
    }
}
